<!--new desing-->

<!--VISTA DESCRIPCION DEL CURSO INTERNO - INSTANCE -->
<!--PARTE 1 BANNER -->

<div class="mx-auto max-w-7xl w-full pt-[50px] md:pt-6">
  <div class="w-full relative overflow-hidden md:rounded-2xl"
    style="background: linear-gradient(135deg, #0a192f 0%, #0e1f3a 30%, #162a45 60%, #1b3250 100%);  box-shadow: 0 8px 32px rgba(10, 25, 47, 0.35);">

    <div class="absolute inset-0 overflow-hidden w-3/5">
      <svg class="absolute inset-0 w-full h-full opacity-10" viewBox="0 0 600 400">
        <g stroke="#00E5FF" stroke-width="0.5">
          <line x1="50" y1="80" x2="200" y2="150" />
          <line x1="200" y1="150" x2="350" y2="90" />
          <line x1="350" y1="90" x2="500" y2="200" />
          <line x1="100" y1="250" x2="250" y2="180" />
          <line x1="250" y1="180" x2="400" y2="300" />
          <line x1="150" y1="350" x2="300" y2="280" />
          <line x1="300" y1="280" x2="450" y2="350" />
        </g>
        <g fill="#00E5FF">
          <circle cx="50" cy="80" r="2.5" opacity="0.6" />
          <circle cx="200" cy="150" r="3" opacity="0.8" />
          <circle cx="350" cy="90" r="2" opacity="0.5" />
          <circle cx="250" cy="180" r="3.5" opacity="0.9" />
          <circle cx="450" cy="350" r="3" opacity="0.8" />
        </g>
      </svg>
      <div class="absolute inset-0 opacity-5"
        style="background-image: radial-gradient(circle, rgba(0, 229, 255, 0.5) 1px, transparent 1px); background-size: 24px 24px;">
      </div>
    </div>
    <div class="absolute right-0 top-0 bottom-0 hidden lg:block w-[48%]" [style.background-image]="instance.mediaUrl"
      style="background-size: cover;
             background-position: center;
                 mask-image: linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 0.3) 25%, rgba(0, 0, 0, 0.65) 60%, rgba(0, 0, 0, 0.8) 100%);">
    </div>

    <!-- Imagen del curso - solo móvil, fondo completo con baja opacidad -->
    <div class="absolute inset-0 block lg:hidden opacity-10" [style.background-image]="instance.mediaUrl"
      style="background-size: cover; background-position: center top;">
    </div>

    <div class="relative z-10 px-5 lg:px-10 py-6 lg:py-10 flex flex-col justify-between min-h-[260px] lg:min-h-[340px] gap-4 lg:gap-0">
      <!-- Breadcrumb + tipo -->
      <div class="w-fit flex items-center gap-1.5 text-xs">
        <button type="button" (click)="goBack()" aria-label="Volver atrás"
          class="shrink-0 text-white/70 hover:text-white transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </button>
        <span class="bg-slate-800/60 px-3 py-1 rounded-full backdrop-blur-sm  text-white/70 whitespace-nowrap">{{ 'api.content-type.course' | translate }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="w-3 h-3 text-white/40">
          <path d="m9 18 6-6-6-6"></path>
        </svg>
        <span class="text-white/70 whitespace-nowrap max-w-[calc(100vw-8rem)] lg:max-w-[420px]  truncate" title="{{ instance.title }}">{{ instance?.provider?.name || company?.name }} — {{ instance.title }}</span>
      </div>
      <!-- Título + descripción + progreso -->
      <div class="max-w-2xl flex flex-col justify-center gap-2">
        <h1 class="text-xl lg:text-3xl font-bold text-white leading-tight"> {{ instance.title }}</h1>
        <div class="journey-description">
          <p class="inner-html text-xs lg:text-sm text-white/80 leading-relaxed mb-2 lg:mb-4 line-clamp-2"
            [innerHTML]="instance.description ? (instance.description | firstSentence | safe:'html') : ('words.undescribed-content' | translate)">
          </p>
        </div>
        <!-- Progress bar -->
        <div class="flex flex-col gap-3 max-w-xl">
          <div class="flex items-center gap-3">
            <div class="flex-1 h-2.5 md:h-2 bg-white/20 rounded-full overflow-hidden">
              <div class="h-full rounded-full bg-progress-gradient" [style.width]="courseProgress + '%'"></div>
            </div>
            <span class="hidden md:inline text-xs text-white/60 whitespace-nowrap">{{ courseProgress }}% {{'words.total-progress' | translate}}</span>
          </div>
          <span class="mobile-only-progress-label text-[10px] text-white/60 uppercase tracking-wider font-semibold">{{ courseProgress }}% {{'words.total-progress' | translate}}</span>
        </div>
      </div>
      <!-- ICONS+BTN -->
      <div class="flex items-center gap-6 flex-wrap">
        <button (click)="startContent()"
          class="flex items-center justify-center gap-2 w-full lg:w-auto px-6 py-2.5 lg:py-2 rounded-full bg-white text-gray-800 lg:bg-white/10 lg:text-white hover:bg-white/90 lg:hover:bg-white/20 backdrop-blur-md text-sm font-semibold transition-all">
                  {{ (subscribed ? 'words.continue' : 'words.start-enrollment') | translate }}
          <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="10" stroke-width="1.5"></circle>
            <polygon points="10,8 16,12 10,16" fill="currentColor"></polygon>
          </svg>
        </button>

        <div class="hidden lg:flex items-center gap-5 text-white text-sm">
          <span [tooltip]="'funnel.adoption.signed-up' | translate" class="flex items-center gap-1"
            *ngIf="instance?.subscribedUsers">
            <i class="fas fa-user text-xs"></i>
            {{ instance.subscribedUsers }}
          </span>
          <span class="flex items-center gap-1.5 opacity-80" [tooltip]="'studio.create.course.duration' | translate"
            [tooltip]="'studio.create.course.duration' | translate">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
            {{convertSecondsToHoursMinutes(instance.duration)}}
          </span>
          <span class="flex items-center gap-1.5 opacity-80" [tooltip]="'words.valoration' | translate">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="w-4 h-4 text-yellow-400">
              <path
                d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
              </path>
            </svg>
            {{ratingInfo?.avgRating}}
            ({{ratingInfo?.totalRatingsCompact}}
            {{'words.valoration' | translate}})
          </span>
          <span class="flex items-center gap-1.5 opacity-80" *ngIf="courseProgress >= 100" [tooltip]="'words.rating' | translate">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <circle cx="12" cy="8" r="6"></circle>
              <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"></path>
            </svg>
            {{'words.rating' | translate}}: {{ courseScore | number:'1.0-0' }}/100
          </span>
        </div>
      </div>

    </div>
  </div>
</div>

<!--PARTE 2 DESCRIPCION --- COMPONENTE IR A SUMARY -->
<app-rating-modal #ratingModal (ratingSubmitted)="handleRating($event)"></app-rating-modal>

<msc-learn-detail-instance-summary [summary]="summary" [instance]="instance" [subscribed]="subscribed"
  [processing]="processing" [isLoaded]="isLoaded" [saved]="saved" (onPlayContent)="playContentCourse()"
  (onSubscribe)="subscribeToContent()" (onUnsubscribe)="modalDelete.open(instance.title)"
  (onOpenConversation)="openConversation()" (onSave)="changeLearnLaterContent()"
  (onRate)="ratingModal.open(ratingInfo)">
</msc-learn-detail-instance-summary>

<msc-card-manager-modal-delete-subscription #modalDelete type="instance" (onSave)="deleteContent($event)">
</msc-card-manager-modal-delete-subscription>